import {observer} from "mobx-react";
import * as React from "react";
import FormBankSelectionFromList from "./FormBankSelectionFromList";
import FormBankSelectionManually from "./FormBankSelectionManually";
import GoogleAnalyticsService from "../../../../../services/Analytics/GoogleAnalyticsService";

interface ILocalState {
    isManually: boolean;
}
interface IProps {
    store: any
}
@observer
export default class FormBankSelectionContainer extends React.Component<IProps> {
    public state: ILocalState = {
        isManually: true
    };

    public componentDidMount = () => {
        GoogleAnalyticsService.virtualPageView("bank-details");
    };
    public render() {
        const {store} = this.props;
        return (
            this.state.isManually?
                <FormBankSelectionManually store={store} backClick={this.changeViewToList} onBankSelected={this.updateSelectedBank} isSending={store.isSending}/>
                :
                <FormBankSelectionFromList bankAccountsData={store.accounts} oneChooseEnterBankManually={this.updateToManually}  onBankSelected={this.updateSelectedBank}/>
        );
    };

    private updateToManually = () => {
        const newState = this.state;
        newState.isManually = true;
        this.setState(newState);
    };

    private updateSelectedBank = (bankDetails?: any) => {
        const {store} = this.props;
        if (bankDetails && bankDetails.account_id) {
            store.formInput.bankAccountDetails = bankDetails.account_id;
            store.updateSelectedAccountDetails(bankDetails.account_id);
        } else {
            store.updateSelectedAccountDetails(bankDetails);
        }
        GoogleAnalyticsService.triggerEvent("signup", "form submission", "bank details");
    }

    private changeViewToList = () => {
        const newState = this.state;
        newState.isManually = false;
        this.setState(newState);
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormBankSelection/FormBankSelectionContainer.tsx